module.exports = "/_next/static/images/bead-info-d4f9d5c582afc28b2491e5d076532228.webp";